<template>
    <div @mouseout="highlight(modelValue)" class="mt-2 flex items-center">
        <div
            v-for="star in 5"
            :key="star"
            :data-test="`rating-${star}`"
            class="shrink-0 cursor-pointer"
            @mouseover="highlight(star)"
            @click="rate(star)"
            :class="[highlighted >= star ? 'text-amber-400' : 'text-gray-200']"
        >
            <StarIcon class="h-8 w-8" aria-hidden="true" />
            <p class="sr-only">
                {{ star }} {{ star === 1 ? "star" : "stars" }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { StarIcon } from "@heroicons/vue/solid";
import { useReviewRating } from "../../functions/useReviewRating";

// Unknown rather than number: the bound value is whatever the last submission carried, and a
// rejected one is redisplayed exactly as it was sent — "4.5" and "" both reach here.
const props = defineProps<{
    modelValue?: unknown;
}>();

const emit = defineEmits<{
    "update:modelValue": [rating: number];
}>();

const { filledStars } = useReviewRating();

// The wrapper's @mouseout restores the fill from the bound value, so both have to be seeded or
// the stars clear the first time the pointer leaves them.
const highlighted = ref(filledStars(props.modelValue));

watch(
    () => props.modelValue,
    (rating) => highlight(rating),
);

function highlight(stars: unknown): void {
    highlighted.value = filledStars(stars);
}

function rate(stars: number): void {
    highlight(stars);
    emit("update:modelValue", stars);
}
</script>
